module.exports = __webpack_public_path__ + "img/mask-app-store.76b4bd75.png";